import React, {useState, useEffect} from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import Arrivi from './pages/Arrivi/Arrivi';
import PianoTuristico from './pages/PianoTuristico/PianoTuristico';
import Report from './pages/Report/Report';
import Projects from './pages/Projects/Projects';
import Navbar from './components/common/Navbar/Navbar';
import Settings from './pages/Settings/Settings';
import './App.css'
import {Amplify, Auth} from 'aws-amplify';
import awsconfig from './userPool.js'
import { withAuthenticator} from '@aws-amplify/ui-react';
Amplify.configure(awsconfig);

const App = () => {
  useEffect(() => {
    const signInUser = async () => {
      try {
        await Auth.signIn(process.env.REACT_APP_LOGIN, process.env.REACT_APP_PASSWORD);
      } catch (error) {
        console.log('Error signing in:', error);
      }
    };

    signInUser();
  }, []);
  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/arrivi" element={<Arrivi />} />
          <Route path="/pianoturistico" element={<PianoTuristico />} />
          <Route path="/report" element={<Report />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/settings" element={<Settings />} />

        </Routes>
      </div>
    </Router>
  );
};

export default App;